<div
  class="status-chip-bg"
  [ngClass]="{
    'status-chip-bg-red': statusColor == statusChipColor.RED,
    'status-chip-bg-yellow': statusColor == statusChipColor.YELLOW,
    'status-chip-bg-blue': statusColor == statusChipColor.BLUE,
    'status-chip-bg-blue-4': statusColor == statusChipColor.BLUE_4,
    'status-chip-bg-green': statusColor == statusChipColor.GREEN,
    'status-chip-bg-grey': statusColor == statusChipColor.GREY,
    'status-chip-bg-white': statusColor == statusChipColor.WHITE
  }"
  [matTooltip]="statusHoverMessage"
  matTooltipPosition="above"
  matTooltipClass="ep-hover-message"
>
  <div class="status-chip-message ep-text-regular-11">
    <app-svg-icon *ngIf="statusHoverMessage?.length > 0 || statusIcon === statusChipIcon.INFO" src="./assets/icons/information-icon.svg"></app-svg-icon>
    <app-svg-icon *ngIf="statusIcon === statusChipIcon.LOCK" src="./assets/icons/ep-lock-4px.svg"></app-svg-icon>
    {{ statusMessage }}
  </div>
  <div class="ep-text-strong-12">{{ statusMessageSubtitle }}</div>
</div>
